import {
    activeCiblesComparateursActifs,
    activePastille,
    afficheValeursCritère,
    ajoutePastille,
    cacheRésultats,
    chargeComparateursSupportés,
    chargeSelectCodeNomValeurs,
    désactiveCiblesComparateursActifs,
    supprimePastille,
    supprimeToutesLesPastilles,
    typeSaisieCourant
} from "./dom.js";
import {Recherche} from "./Recherche.js";
import {CritèreRecherche} from "./CritèreRecherche.js";
import {opérateurParDéfaut, TypeSaisieValeur, Événements} from "./constantes.js";
import {Cibles} from "./Cibles.js";
import {OptionRecherche} from "./OptionRecherche.js";
import {Comparateurs} from "./ComparateurCritère.js";

export class ConstructeurDeRecherche {

    recherche = new Recherche();

    constructor(gestionnaireAlphabetPhonétique) {
        this.gestionnaireAlphabetPhonétique = gestionnaireAlphabetPhonétique;
        this.critèresCiblesChoix = document.getElementById("critèresCiblesChoix");
        this.critèresComparateursChoix = document.getElementById("critèresComparateursChoix");
        this.critèreValeurTexte = document.getElementById("critèreValeurTexte");
        this.critèreValeurChoixUnique = document.getElementById("critèreValeurChoixUnique");
        this.critèreValeurChoixMultiples = document.getElementById("critèreValeurChoixMultiples");
        this.filtrePastilles = document.getElementById("filtrePastilles");
        this.boutonSupprimerTousLesCritères = document.getElementById("supprimeTousLesCritères");
    }

    initialise(recherche) {

        this.critèresCiblesChoix.addEventListener("change", (event) => this.changementDeCible(event));
        this.critèresComparateursChoix.addEventListener("change", (event) => this.changementComparateur(event))
        this.critèreValeurChoixUnique.addEventListener("submit", (event) => this.ajouteCritère(event));
        this.critèreValeurTexte.addEventListener("keyup", (event) => this.ajouteCritèreTexte(event));

        document.getElementById("ajouteCritèreBouton")
            .addEventListener("click", (e) => this.ajouteCritère(e));

        document.getElementById("supprimeCritèreBouton")
            .addEventListener("click", (e) => this.supprimeCritère());

        document.getElementById("supprimeTousLesCritères")
            .addEventListener("click", (e) => this.supprimeTousLesCritères());

        chargeSelectCodeNomValeurs(this.critèresCiblesChoix, Cibles);

        if (recherche && Object.keys(recherche).length > 0) {
            this.chargeNouvelleRecherche(recherche);
        }

        this.filtreCibles();

    }

    filtreCibles() {
        // Filtrer les Cibles en fonction de la présence ou nom d'au moins une Liste MEQ dans les critères de la recherche courante
        const préfixeMEQ = "MEQ_";
        if (this.recherche && this.recherche.hasCible(Cibles.LISTE_MEQ)) {
            this.afficheCibles(true, préfixeMEQ);
        } else {
            this.afficheCibles(false, préfixeMEQ);
            this.supprimeCibles(préfixeMEQ);
        }

        // Filtrer également les cibles en fonction de Togglz. Pas hyper sécuritaire, mais pas trop risqué - rien de secret.
        const préfixeBETA = "BETA_";
        if(typeof beta !== 'undefined' && beta === true) {
            this.afficheCibles(true, préfixeBETA);
        }
        else {
            this.afficheCibles(false, préfixeBETA);
            this.supprimeCibles(préfixeBETA);
        }


        activeCiblesComparateursActifs(this);

    }

    supprimeCibles(préfixe) {
        // supprimer tous les critères éventuels MEQ_* de la recherche ainsi que leurs pastilles
        // let regex = /^MEQ_.*/;
        const regex = new RegExp(`^${préfixe}.*`);
        [...this.recherche.critères.keys()].forEach((critèreId) => {
            if (regex.test(this.recherche.critères.get(critèreId).cible)) {
                this.supprimeCritère(critèreId);
            }
        })
    }

    afficheCibles(affiche, préfixe) {
        let optionDisplay = "none";
        if (affiche) {
            optionDisplay = "block"
        }
        Object.values(this.critèresCiblesChoix.getElementsByTagName("option"))
            .filter(option => option.value.startsWith(préfixe))
            .forEach(option => option.style.display = optionDisplay);
    }

    changementDeCible(événement) {

        const cibleCourante = this.getCibleCourante();

        const cibleComparateursActifs = [...this.recherche.critères.values()]
            .filter(critère => critère.cible === cibleCourante)
            .map(critère => critère.comparateur)
            .join(opérateurParDéfaut);

        chargeComparateursSupportés(this, cibleCourante, cibleComparateursActifs);

        this.gestionnaireAlphabetPhonétique.afficheOuMasqueClavierAPI(cibleCourante);
    }

    changementComparateur(événement) {
        afficheValeursCritère(this);
    }

    ajouteCritèreTexte(e) {
        if (e.key === 'Enter') {
            this.ajouteCritère()
        }
        e.preventDefault();
        return true;
    }

    getCibleCouranteÉlément() {
        return this.critèresCiblesChoix.options[this.critèresCiblesChoix.selectedIndex];
    }

    getCibleCourante() {
        return this.getCibleCouranteÉlément().value;
    }

    getComparateurCourantÉlément() {
        return this.critèresComparateursChoix.options[this.critèresComparateursChoix.selectedIndex];
    }

    getComparateurCourant() {
        return this.getComparateurCourantÉlément().value;
    }

    ajouteCritère(e) {
        const critère = this.getCritèreCourant();

        if (!critère.valeurs || critère.valeurs.length === 0 /*|| critère.valeurs[0].trim().length === 0*/) {
            console.log("Pas d'ajout de critère sans valeur.", critère.valeurs);
            return;
        }

        if (!(this.recherche instanceof Recherche)) {
            this.recherche = new Recherche();
        }

        // Ajout / maj du critère de la recherche courante
        this.ajouteCritèreÀLaRecherche(this.recherche, critère);
        this.filtreCibles();

        this.recherche.nom = "";
        this.recherche.hash = Recherche.getHash(this.recherche);

        // Générer événement "nouveauCritère"
        const nouveauCritèreÉvénement = new CustomEvent(Événements.NOUVEAU_CRITÈRE, {
            detail: {"critère": critère, "recherche": this.recherche}
        });
        document.dispatchEvent(nouveauCritèreÉvénement);

        this.boutonSupprimerTousLesCritères.style.display = "block";

    }

    setOption(option) {
        this.recherche.options.set(option.code, option);
        this.recherche.hash = Recherche.getHash(this.recherche);
    }

    setOptions(options) {
        options.forEach((option) => {
            this.recherche.options.set(option.code, option);
        });
        this.recherche.hash = Recherche.getHash(this.recherche);
    }


    ajouteCritèreÀLaRecherche(recherche, critèreRecherche) {
        recherche.critères.set(this.getClé(critèreRecherche), critèreRecherche);
        this.getCibleCouranteÉlément().classList.add("actif");
        this.getComparateurCourantÉlément().classList.add("actif");
    }

    supprimeCritère(critèreId) {

        const critère = critèreId ? this.recherche.critères.get(critèreId) : this.getCritèreCourant();

        this.getCibleCouranteÉlément().classList.remove("actif");
        this.getComparateurCourantÉlément().classList.remove("actif");

        this.recherche.critères.delete(this.getClé(critère));

        if (this.recherche.critères.size === 0) {
            this.boutonSupprimerTousLesCritères.style.display = "none";
            // Recharger les valeurs par défaut
            this.changementComparateur();
        } else {
            this.setCritèreCourant(critère);
        }

        supprimePastille(this, critère);
        this.filtreCibles();

        this.recherche.nom = "";
        this.recherche.hash = Recherche.getHash(this.recherche);

        document.dispatchEvent(
            new CustomEvent(Événements.SUPPRESSION_CRITÈRE, {
                    detail: {
                        "critère": critère,
                        "recherche": this.recherche
                    }
                }
            )
        );
    }

    /**
     * Supprime tous les critères = supprimer la recherche
     */
    supprimeTousLesCritères() {
        let rechercheSupprimée = this.recherche.clone();
        this.recherche = new Recherche();

        supprimeToutesLesPastilles(this);
        désactiveCiblesComparateursActifs(this);
        this.filtreCibles();

        // Recharger les valeurs par défaut
        this.changementComparateur();

        this.boutonSupprimerTousLesCritères.style.display = "none";

        cacheRésultats();

        document.dispatchEvent(
            new CustomEvent(Événements.SUPPRESSION_RECHERCHE, {
                    detail: {
                        "recherche": rechercheSupprimée
                    }
                }
            )
        );

    }


    getCritèreCourant() {
        return new CritèreRecherche(
            this.getCibleCourante(),
            this.getComparateurCourant(),
            this.getValeursCourantes());
    }

    getCritèreRechercheParDéfaut() {
        // Anciennement retournait le premier critère de la Map des critères convertie en Array de valeur
        // Semblerait pas trop intuitif et trop de clic pour juste raffiner la recherche sur le "mot".
        // let critères = [...this.recherche.critères].map(([codeCritère, critère]) => critère);
        // return critères[0];

        // Retourne toujours la graphie (recherche sur le mot)
        return new CritèreRecherche(Cibles.GRAPHIE.code, Comparateurs.COMMENCE_PAR.code);
    }

    setCritèreCourant(critère) {

        if (!(critère instanceof CritèreRecherche)) return;

        this.setCibleCourante(critère.cible);
        this.setComparateurCourant(critère.comparateur);

        activePastille(this.getPastille(critère));

    }

    setCibleCourante(cible) {
        const isCible = (élément) => élément.value === cible;
        this.critèresCiblesChoix.selectedIndex = [...this.critèresCiblesChoix.options].findIndex(isCible);
        this.changementDeCible();
    }

    setComparateurCourant(comparateur) {
        const isComparateur = (élément) => élément.value === comparateur;
        this.critèresComparateursChoix.selectedIndex = [...this.critèresComparateursChoix.options].findIndex(isComparateur);
        this.changementComparateur();
    }

    getCritère(critèreId) {
        return this.recherche.critères.get(critèreId);
    }

    isCritèreActif(cible, comparateur) {
        if (!(this.recherche instanceof Recherche)) return false;
        const cléCibleComparateur = this.getCléCibleComparateur(cible, comparateur);
        return this.recherche.critères.has(cléCibleComparateur);
    }

    hasCritèreActif(cible, comparateur) {
        if (!(this.recherche instanceof Recherche)) return false;
        return this.recherche.critères.size > 0;
    }

    getValeursCourantes() {
        let valeurs = [];

        switch (typeSaisieCourant) {
            case TypeSaisieValeur.TEXTE:
                valeurs.push(this.critèreValeurTexte.value);
                break;
            case TypeSaisieValeur.CHOIX_UNIQUE:
                valeurs.push(this.critèreValeurChoixUnique.value);
                break;
            case TypeSaisieValeur.CHOIX_MULTIPLE:
                const checkboxesCochées = this.critèreValeurChoixMultiples.querySelectorAll('input[type="checkbox"]:checked');
                valeurs = Array.from(checkboxesCochées).map(checkbox => checkbox.value);
                break;
        }
        return valeurs;
    }

    getCléCibleComparateur(cible, comparateur) {
        if (cible && comparateur)
            return cible + "-" + comparateur;
        else
            return "cléInconnue";
    }

    getClé(critère) {
        if (!critère) return undefined;
        return this.getCléCibleComparateur(critère.cible, critère.comparateur)
    }

    chargeNouvelleRecherche(recherche) {
        if (recherche && Object.keys(recherche).length === 0) {
            return;
        }
        try {
            // Très important de "cloner" la recherche (essentiellement pour celle qui proviennent des suggestions, car
            // les recherches originales seraient modifiées lors d'édition éventuelle des critères par la suite).
            this.recherche = recherche.clone();

            supprimeToutesLesPastilles(this);

            const critères = this.recherche.critères;
            if (critères) {
                [...critères.values()].forEach((critère) => {
                    ajoutePastille(this, critère);
                })
            }

            this.setCritèreCourant(this.getCritèreRechercheParDéfaut());

            if (this.recherche.options.get(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code).valeur === "oui") {
                document.getElementById("filtreOption-lemmesSeulement").checked = true;
            } else if (this.recherche.options.get(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code).valeur === "oui") {
                document.getElementById("filtreOption-aucun").checked = true;
            } else {
                document.getElementById("filtreOption-verbesConjugués").checked = true;
            }

            this.boutonSupprimerTousLesCritères.style.display = "block";

            activeCiblesComparateursActifs(this);

            // Générer événement "nouvelleRecherche"
            const nouvelleRechercheÉvénement = new CustomEvent(Événements.NOUVELLE_RECHERCHE, {
                detail: {"recherche": this.recherche}
            });

            document.dispatchEvent(nouvelleRechercheÉvénement);

        } catch (e) {
            console.error("recherche : ", recherche);
            console.error(e);
        }
    }

    getPastille(critère) {
        return this.filtrePastilles.querySelector("#" + this.getPastilleId(critère));
    }

    getPastilleId(critère) {
        return this.getClé(critère);
    }

}

